import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import { mdiChevronLeft, mdiChevronRight, mdiInstagram } from '@mdi/js';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdiSvg',
        values: {
            prev: mdiChevronLeft,   // flechas del slider
            next: mdiChevronRight,
            instagram: mdiInstagram,
        },
    },
    theme: {
        themes: {
            light: {
                primary: "323232", // #E53935
                secondary: "E5E5E5", // #FFCDD2
                accent: "000000", // #3F51B5
                background: "323232",
            },
        },
        dark: {
            primary: "323232", // #E53935
            secondary: "E5E5E5", // #FFCDD2
            accent: "000000", // #3F51B5
            background: "323232",
        },
    },
});
